import { findEnvVar as findPrefixedEnvVar } from '@dashboard-experience/utils';

// `findEnvVar` from `@dashboard-experience/utils` defaults to the CRA-era
// `REACT_APP_` prefix. Candidate-portal env vars are `VITE_`-prefixed
// (ECDEX-2598), so this wrapper pins the prefix in one place.
export const findEnvVar = (name: string): string | undefined =>
  findPrefixedEnvVar(name, 'VITE_');
